// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2ZXm8","colMaxWidth":"Table_colMaxWidth__8zJA2"};